
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import tabbar from '@/components/tabbar'
export default{
components: {
XHeader,
Group,
tabbar,
XButton,
Cell
},
data(){
return{
uInfs:{}
}
},
mounted(){
this.lineCanvas({
el: document.getElementById("canvas"),//绘制canvas的父级div
clearEl: document.getElementById("clearCanvas"),//清除按钮
saveEl: document.getElementById("saveCanvas"),//保存按钮



});
},
methods:{
lineCanvas(obj) {
this.linewidth = 1;
this.color = "#000000";
for (var i in obj) {
this[i] = obj[i];
};
this.canvas = document.createElement("canvas");
this.el.appendChild(this.canvas);
this.cxt = this.canvas.getContext("2d");
this.canvas.width = this.el.clientWidth;
this.canvas.height = this.el.clientHeight;
this.cxt.fillStyle = "transparent";
this.cxt.fillRect(0, 0, this.canvas.width, this.canvas.width);
this.cxt.strokeStyle = this.color;
this.cxt.lineWidth = this.linewidth;
this.cxt.lineCap = "round";
this.cxt.lineJoin = 'round';
this.cxt.shadowBlur = 1;
this.cxt.shadowColor = '#000';

this.canvas.addEventListener("touchstart", function(e) {
this.cxt.beginPath();
this.cxt.moveTo(e.changedTouches[0].pageX-10, e.changedTouches[0].pageY-84);
}.bind(this), false);

this.canvas.addEventListener("touchmove", function(e) {
this.cxt.lineTo(e.changedTouches[0].pageX-10, e.changedTouches[0].pageY-84);
this.cxt.stroke();
}.bind(this), false);

this.canvas.addEventListener("touchend", function() {
this.cxt.closePath();
}.bind(this), false);

this.clearEl.addEventListener("click", function() {
this.cxt.clearRect(0, 0, this.canvas.width, this.canvas.height);
}.bind(this), false);

this.saveEl.addEventListener("click", function() {
var imgBase64 = this.canvas.toDataURL("image/png");
console.log(imgBase64);


var image = this.canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
window.location.href=image;




}.bind(this), false);
},
}
}



// WEBPACK FOOTER //
// ./src/pages/signature.vue